// @ts-nocheck
const listeners = new Set()

let currentState = {
  isOnline: true,
  lastErrorAt: null,
}

const notify = () => {
  listeners.forEach((listener) => listener(currentState))
}

export const getBackendStatus = () => currentState

export const reportBackendOnline = () => {
  if (currentState.isOnline) {
    return
  }
  currentState = {
    ...currentState,
    isOnline: true,
  }
  notify()
}

export const reportBackendOffline = () => {
  const now = Date.now()
  if (!currentState.isOnline && currentState.lastErrorAt && now - currentState.lastErrorAt < 3000) {
    return
  }
  currentState = {
    isOnline: false,
    lastErrorAt: now,
  }
  notify()
}

export const subscribeBackendStatus = (listener) => {
  listeners.add(listener)
  listener(currentState)
  return () => listeners.delete(listener)
}
